import React from 'react'

export const FooterWaveAboutLessSvg = () => (
  <svg
    width="100%"
    viewBox="0 0 263 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M263 0H0V32C16.3562 32 43.5711 28.5898 68.8108 25.4272C69.6414 25.3231 70.4698 25.2193 71.2957 25.1159C99.6188 21.5694 116.916 20.0328 131.457 20.0328C145.19 19.768 169.353 21.0507 201.483 25.904C232.787 30.6327 244.118 32 263 32V0Z"
      fill="#FFDED0"
      fillOpacity={0.48}
    />
  </svg>
)
